import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

/**
 * Standard empty-state for tables, lists, search-no-results.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center text-center px-6 py-12',
        className,
      )}
    >
      {icon && (
        <div className="w-12 h-12 grid place-items-center rounded-full bg-zinc-100 dark:bg-zinc-800 text-zinc-400 dark:text-zinc-500 mb-4">
          {icon}
        </div>
      )}
      <h3 className="text-base font-semibold text-zinc-950 dark:text-zinc-50">
        {title}
      </h3>
      {description && (
        <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-300 max-w-md">
          {description}
        </p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
